import { gql } from '@apollo/client'

export const LIST_TERRITORY_TAGS_PAGINATED = gql`
  query listTerritoryTagsPaginated($pagination: TerritoryTagsPaginationInput!, $providers: [Providers!]) {
    listTerritoryTagsPaginated(pagination: $pagination) {
      totalCount
      cursor
      data {
        name
        territoryId
        isFollowed
        territoryPerformance {
          totalPosts(providers: $providers)
          sampledMetrics(filters: { providers: $providers }) {
            avgEngagement
            avgViews
          }
        }
        ... on TerritoryTag {
          daysRemaining
          expiresAt
          updatedAt
          status
        }
      }
    }
  }
`

export const CREATE_TAG = gql`
  mutation createTag($input: CreateTagInput!) {
    createTag(input: $input) {
      code
      message
      title
      success
    }
  }
`
export const UPDATE_TAGS_STATE = gql`
  mutation updateTagsState($input: [UpdateTagStateInput!]!) {
    updateTagsState(input: $input) {
      title
      message
      code
      success
    }
  }
`
